import withStyles from '@mui/styles/withStyles';
import {Slider} from "@mui/material";

const ShapeSlider = withStyles({
    root: {},
    thumb: {
        height: 22,
        width: 22,
        backgroundColor: '#3F51B5',
        border: "solid 1px gold"
    },
    active: {},
    valueLabel: {},
    track: {},
    rail: {
        height: 0
    },
    mark: {},
    markActive: {},
})(Slider);

export {ShapeSlider};
